/* eslint-disable no-unused-vars */
import { PowerBIResponse } from 'models/powerbi';
import { ApiServiceBase } from './base/api-service-base';

const baseEndpoint = 'embedded';

export interface IPowerBIApiService {
	getPowerBIDataInsightsService(pageFromUrl:string | null): Promise<PowerBIResponse>;
	getPowerBICampaignsService(pageFromUrl:string | null): Promise<PowerBIResponse>;
	getPowerBIDashboardService(pageFromUrl:string | null): Promise<PowerBIResponse>;
	getPowerBIOpsInsightsService(pageFromUrl:string | null): Promise<PowerBIResponse>;
	getPowerBICXInsightsService(pageFromUrl:string | null): Promise<PowerBIResponse>;
	getEmbeddedToken(pageName: string): Promise<PowerBIResponse>;
}

export class PowerBIApiService extends ApiServiceBase implements IPowerBIApiService {
	public async getPowerBIDataInsightsService(pageFromUrl: string | null | undefined): Promise<PowerBIResponse> {
	 	const hasValidParam = pageFromUrl !== null && pageFromUrl !== undefined && pageFromUrl.trim() !== '';
		const url = hasValidParam
			? `${baseEndpoint}/data-insights?urlparams=${encodeURIComponent(pageFromUrl)}`
			: `${baseEndpoint}/data-insights`;
			return await this.GetFromApi<any>(url);
	}

	public async getPowerBIDashboardService(pageFromUrl: string | null | undefined): Promise<PowerBIResponse> {
		const hasValidParam = pageFromUrl !== null && pageFromUrl !== undefined && pageFromUrl.trim() !== '';
		const url = hasValidParam
			? `${baseEndpoint}/dashboard?urlparams=${encodeURIComponent(pageFromUrl)}`
			: `${baseEndpoint}/dashboard`;

		return await this.GetFromApi<any>(url);
	}


	public async getPowerBICampaignsService(pageFromUrl: string | null | undefined): Promise<PowerBIResponse> {
		const hasValidParam = pageFromUrl !== null && pageFromUrl !== undefined && pageFromUrl.trim() !== '';
		const url = hasValidParam
			? `${baseEndpoint}/campaigns?urlparams=${encodeURIComponent(pageFromUrl)}`
			: `${baseEndpoint}/campaigns`;
			return await this.GetFromApi<any>(url);
	}

	public async getEmbeddedToken(pageName: string): Promise<PowerBIResponse> {
		return await this.GetFromApi<any>(`${baseEndpoint}/refresh-token/${pageName}`);
	}

	public async getPowerBIOpsInsightsService(pageFromUrl: string | null | undefined): Promise<PowerBIResponse> {
		const hasValidParam = pageFromUrl !== null && pageFromUrl !== undefined && pageFromUrl.trim() !== '';
		const url = hasValidParam
			? `${baseEndpoint}/ops-insights?urlparams=${encodeURIComponent(pageFromUrl)}`
			: `${baseEndpoint}/ops-insights`;
			return await this.GetFromApi<any>(url);
	}

	public async getPowerBICXInsightsService(pageFromUrl: string | null | undefined): Promise<PowerBIResponse> {
		const hasValidParam = pageFromUrl !== null && pageFromUrl !== undefined && pageFromUrl.trim() !== '';
		const url = hasValidParam
			? `${baseEndpoint}/cx-insights?urlparams=${encodeURIComponent(pageFromUrl)}`
			: `${baseEndpoint}/cx-insights`;
			return await this.GetFromApi<any>(url);
	}
}
